import { observable, action, computed } from 'mobx';

class ProductStore {
    @observable selectedProduct = null;
    @observable isProductSelectorVisible = false;
    @observable products = [
        { id: 'FORMATION', name: 'Formação Conquer' },
        { id: 'TEENS', name: 'Conquer Teens' }
    ];

    constructor() {
        this.loadFromLocalStorage();
    }

    loadFromLocalStorage = () => {
        const stored = localStorage.getItem('product-wup-teachers-desk');
        if (stored) {
            try {
                this.selectedProduct = JSON.parse(stored);
            } catch (e) {
                this.selectedProduct = null;
            }
        }
    };

    @action
    setProduct(productId) {
        this.selectedProduct = productId;
        localStorage.setItem('product-wup-teachers-desk', JSON.stringify(productId));
    }

    @action
    checkIfShowProductSelector(unit) {
        const AGUA_VERDE_UNIT_NAME = 'Conquer Água Verde';
        this.isProductSelectorVisible = (unit && unit.name === AGUA_VERDE_UNIT_NAME);

        if (!this.isProductSelectorVisible && !this.selectedProduct) {
            this.selectedProduct = 'FORMATION';
        }
    }

    @action
    resetProductSelection() {
        this.selectedProduct = null;
        this.isProductSelectorVisible = false;
        localStorage.removeItem('product-wup-teachers-desk');
    }

    @computed
    get currentProduct() {
        return this.products.find(p => p.id === this.selectedProduct);
    }

    @computed
    get mustSelectProduct() {
        return this.isProductSelectorVisible && !this.selectedProduct;
    }
}

export default new ProductStore();



// WEBPACK FOOTER //
// ./src/stores/ProductStore.js